import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";

export default function NoticeBoard() {
  const [notices, setNotices] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    api("/api/notices").then(setNotices).catch((err) => setError(err.message));
  }, []);

  return (
    <main className="bg-slate-50 px-4 py-16">
      <section className="mx-auto max-w-6xl">
        <p className="text-sm font-bold uppercase tracking-[0.25em] text-emerald-700">Official Updates</p>
        <h1 className="mt-3 text-4xl font-black text-slate-900">Notice Board</h1>
        <p className="mt-3 max-w-2xl text-slate-600">Important announcements for applicants, students, staff, and the general public.</p>

        {error && <div className="mt-6 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}

        <div className="mt-8 grid gap-4 md:grid-cols-2">
          {notices.map((notice) => (
            <article key={notice.id} className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
              <div className="flex flex-wrap gap-2">
                <span className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-bold text-emerald-700">{notice.category}</span>
                <span className={`rounded-full px-3 py-1 text-xs font-bold ${notice.priority === "urgent" ? "bg-red-100 text-red-700" : "bg-slate-100 text-slate-700"}`}>{notice.priority}</span>
              </div>
              <h2 className="mt-4 text-xl font-bold text-slate-900">{notice.title}</h2>
              <p className="mt-2 line-clamp-3 text-sm text-slate-600">{notice.body}</p>
              <Link to={`/notice-board/${notice.slug}`} className="mt-5 inline-flex rounded-xl bg-emerald-700 px-4 py-2 text-sm font-bold text-white">Read Notice</Link>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
